import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFloppyDisk = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#a)",
			children: /* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeLinejoin: "round",
				strokeWidth: 1.5,
				d: "M12.083 1.667v4.167h-6.25V1.667m-2.083 0h10.417l4.166 4.167V16.25a2.083 2.083 0 0 1-2.083 2.084H3.75a2.083 2.083 0 0 1-2.083-2.084V3.75A2.083 2.083 0 0 1 3.75 1.667Zm4.167 10.417a2.083 2.083 0 1 0 4.166 0 2.083 2.083 0 0 0-4.166 0Z"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "a",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				d: "M0 0h20v20H0z"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgFloppyDisk);
export { ForwardRef as ReactComponent };
